import GameScreen from '../components/GameScreen';
import useViewportScale from '../hooks/useViewportScale';

function WaitingForDrawingsScreen({ currentPrompt, responseTimeLeft, submittedPlayers, players, currentJudgeId, disableTimers }) {
  const px = useViewportScale();
  const submittedIds = new Set((submittedPlayers || []).map(sp => sp.playerId));

  return (
    <GameScreen
      backgroundImage="/waiting-bg1.png"
      introSound="/Alright Poodles Here is your Prompt.m4a"
      title={currentPrompt}
      contentPosition="top"
      countdownSound={!disableTimers ? '/countdown-5.m4a' : undefined}
      countdownAt={5}
      timeLeft={responseTimeLeft}
      players={players}
      playerLayout="grid"
      playerSize={px(230)}    
      playerAnimate
      playerOpacityFn={(player) => submittedIds.has(player.id) ? 1 : 0.4}
      playerPosition={{
        position: 'absolute',
        top: '25%',
        left: '5%',
        width: '50%',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      }}
    />
  );
}

export default WaitingForDrawingsScreen;
